module.exports = __webpack_public_path__ + "img/pr2-album.f6faca76.jpg";